var map = {
	"./diamond-carat-1.jpg": 125,
	"./diamond-carat-1@2x.jpg": 80,
	"./diamond-carat-1@3x.jpg": 81,
	"./diamond-carat-2.jpg": 126,
	"./diamond-carat-2@2x.jpg": 82,
	"./diamond-carat-2@3x.jpg": 83,
	"./diamond-carat-3.jpg": 127,
	"./diamond-carat-3@2x.jpg": 84,
	"./diamond-carat-3@3x.jpg": 85,
	"./diamond-carat-4.jpg": 128,
	"./diamond-carat-4@2x.jpg": 86,
	"./diamond-carat-4@3x.jpg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;